import React, { FC } from "react";

import { Text } from "@Design";

export const EmptyResults: FC<{}> = () => (
  <Text>Sorry, no search results matched the criteria.</Text>
);
